export default __webpack_public_path__ + "static/media/stripe.3feee00c.svg";